import { Options } from "ngx-google-places-autocomplete/objects/options/options";

export const OPTIONS: Partial<Options> = {
    componentRestrictions: {
        country: 'AU'
    },
}